export default "__VITE_ASSET__BKLyRH$l__"